export { default as Adhd } from './Adhd';
export { default as Anxiety } from './Anxiety';
export { default as BipolarDisorder } from './BipolarDisorder';
export { default as Cap } from './Cap';
export { default as Depression } from './Depression';
export { default as Ocd } from './Ocd';
export { default as Ptsd } from './Ptsd';

export const iterableIconTypes = [
  'Adhd',
  'Anxiety',
  'BipolarDisorder',
  'Cap',
  'Depression',
  'Ocd',
  'Ptsd',
] as const;

export type IconTypes = typeof iterableIconTypes[number];
